/**
 * College Compare
 */
$(document).on("ready", function () {
    if ($(".college-compare").length ) {
      $(".preferences").on("click", function (e) {
        e.preventDefault();
        $("#preferences").toggleClass("closed");
      });
      $("#my-colleges").on("click", function (e) {
        e.preventDefault();
        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          data: {action: 'fw_my_colleges', 'compare': true},
          success: function (data) {

            addOverlay('my-colleges college-picker', data);
            $('#overlay .add span').off('click');
            $('#overlay').on('click', '.add span', function () {
              var $add = $(this);
              if ($add.hasClass('remove')) {
                $add.text('Add').removeClass('remove');
                $add.toggleClass('primary secondary');
                $('.selected').each(function () {
                  if ($(this).attr('data-id') === $add.attr('id')) {
                    var $tr = $add.closest('tr');
                    $(this).attr('data-id', '');
                    $(this).html('<td class="college">&nbsp;</td><td class="remove"></td>');
                    // $('#overlay').remove();
                    return false;
                  }
                });
              } else {
                var count = $('.selected').length;
                var exists = false;
                $('.selected').each(function () {
                  if ($(this).attr('data-id') === $add.attr('data-college-id')) {
                    exists = true;
                  }
                });
                if (exists) {
                  alert('This school is already selected.');
                  return false;
                }
                $('.selected').each(function () {
                  if ($(this).attr('data-id') === '') {
                    var $tr = $add.closest('tr');
                    $(this).attr('data-id', $add.attr('id'));
                    $(this).html('<td class="college"><input type="hidden" name="SchoolID[]" value="' + $add.attr('id') + '" />' + $tr.children('.name').text() + '</td><td class="remove">X</td>');
                    // $('#overlay').remove();
                    $add.text('Remove').addClass('remove');
                    $add.toggleClass('primary secondary');
                    return false;
                  }
                  if (!--count) {
                    alert('You cannot add more than 5 colleges.  Please remove a school.');
                  }
                });
              }
            });
          },
          error: function () {
          }
        });
      });
      $("#browse-colleges").on("click", function (e) {
        e.preventDefault();
        $.ajax({
          url: "/wp-admin/admin-ajax.php",
          data: {
            action: 'fw_all_colleges',
            compare: true,
          },
          success: function (data) {
            addOverlay("all-colleges college-picker", data);
            //$('#olContent').append('<p style="text-align:center; padding:20px 0;"><a href="#" class="close btn primary">Finished Adding</a></p>')
            $("#overlay li").on("click", function () {
              var which = $(this).attr("data-which");
              $(".tab, #overlay li").removeClass("active");
              $(this).addClass("active");
              $("#tab" + which).addClass("active");
            });
            $(".tab a").on("click", function (e) {
              e.preventDefault();
              var $add = $(this);
              var exists = false;
              $(".selected").each(function () {
                if ($(this).attr("data-id") === $add.attr("data-id")) {
                  exists = true;
                }
              });
              if (exists) {
                alert("This school is already selected.");
                return false;
              }
              var count = $(".selected").length;
              $(".selected").each(function () {
                if ($(this).attr("data-id") === "") {
                  $(this).attr("data-id", $add.attr("data-id"));
                  $(this).html(
                      '<td class="college"><input type="hidden" name="SchoolID[]" value="' +
                      $add.attr("data-id") +
                      '" /><!--<a href="' +
                      fullBase +
                      "/search-colleges/search-results/?SchoolID=" +
                      $add.attr("data-id") +
                      '">-->' +
                      $add.attr("data-name") +
                      '<!--</a>--></td><td class="remove">X</td>'
                  );
                  //$('#overlay').remove();
                  return false;
                }
                if (!--count) {
                  alert("You cannot add more than 5 colleges.  Please remove a school.");
                }
              });
            });
          },
          error: function () {
          },
        });
      });
      $(document).on("click", "td.remove", function () {
        var $tr = $(this).closest("tr");
        $tr.attr("data-id", "");
        $tr.children(".college, .remove").html("&nbsp;");
      });
      $(document).on("click", "th .remove", function () {
        var id = $(this).closest("th").attr("id");
        if ($(this).closest("th").hasClass("plan")) id = "plan" + id;
        var $tr = $(".selected[data-id=" + id + "]");
        $tr.children(".college, .remove").html("&nbsp;");
        $tr.attr("data-id", "");
        $.ajax({
          type: "GET",
          url: "/wp-admin/admin-ajax.php",
          data: $("#college-compare").serialize() + '&action=fw_college_comparison',
          success: function (data) {
            $("#results").html(data);
            $("html, body").animate(
                {
                  scrollTop: $("#results").offset().top,
                },
                500
            );
          },
          error: function (data) {
            console.log(data);
          },
        });
      });
      $(document).on("click", ".listAdd i", function () {
        var $t = $(this).closest("th");
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          data: {
            action: 'fw_fakeSaveCollege',
            SchoolID: $(this).closest("th").attr("id"),
          },
          success: function (data) {
            $t.children(".listAdd").remove();
            $t.append('<span class="listRemove"><i class="fa fa-check"></i></span>');
          },
          error: function (data) {
            console.log(data);
          },
        });
      });
      $(document).on("click", ".listRemove i", function () {
        var $t = $(this).closest("th");
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          data: {
            action: 'fw_fakeSaveCollege',
            SchoolID: $(this).closest("th").attr("id"),
            remove: 1,
          },
          success: function (data) {
            $t.closest("th").children(".listRemove").remove();
            $t.closest("th").append('<span class="listAdd"><i style="font-style:normal; border:0;">Add to My List</i></a>');
          },
          error: function (data) {
            console.log(data);
          },
        });
      });
      $(".college-compare .submit").on("click", function () {
        $.ajax({
          type: "GET",
          url: "/wp-admin/admin-ajax.php",
          data: 'action=fw_college_comparison&' + $("#college-compare").serialize(),
          success: function (data) {
            $("#results").html(data);
            $("html, body").animate(
                {
                  scrollTop: $("#results").offset().top,
                },
                500
            );
          },
          error: function (data) {
            console.log(data);
          },
        });
      });
      $(".college-compare .save").on("click", function (e) {
        e.preventDefault();
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          data: 'action=fw_college_comparison_save&' + $("#college-compare").serialize(),
          success: function (data) {
            addOverlay("college-compare", data);
            $("#overlay .save").on("click", function (e) {
              e.preventDefault();
              $("#saveName").val($("#saveNameField").val());
              $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                data: 'action=fw_college_comparison_save&' + $("#college-compare").serialize(),
                success: function (data) {
                  $("#overlay").remove();
                  $("#saveName").val("");
                },
                error: function (data) {
                  console.log(data);
                },
              });
            });
            $("#overlay .remove").on("click", function (e) {
              e.preventDefault();
              $("#saveName").val($(this).attr("data-name"));
              $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                data: {
                  action: 'fw_college_comparison_save',
                  saveName: $(this).attr("data-name"),
                  remove: "true",
                },
                success: function (data) {
                  $("#overlay").remove();
                  $("#saveName").val("");
                },
                error: function (data) {
                  console.log(data);
                },
              });
            });
          },
          error: function (data) {
            console.log(data);
          },
        });
      });
      $("#selectCollege").on("change", function () {
        var val = $(this).val();
        var text = $("#selectCollege option:selected").text();
        var exists = false;
        $(".selected").each(function () {
          if ($(this).attr("data-id") === val) {
            exists = true;
          }
        });
        if (exists) {
          return false;
        }
        $(".selected").each(function () {
          if ($(this).attr("data-id") === "") {
            $(this).attr("data-id", val);
            $(this).html('<td class="college"><input type="hidden" name="SchoolID[]" value="' + val + '" />' + text + '</td><td class="remove">X</td>');
            return false;
          }
        });
        $("#selectCollege").select2("val", "", true);
        console.log(1282);
      });
      $(document).on("click", "tr.head", function () {
        var which = $(this).attr("data-which");
        $(this).toggleClass("closed");
        $("tr." + which + ":not(.head)").toggleClass("hidden");
      });
    }
});